import { useEffect, useLayoutEffect } from 'react';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

import Helmet from '@/components/meta/Helmet';
import CalendarTemplate from '@/components/templates/Schedule/Calendar';
import { DATE_PARAM_KEY } from '@/config/constants/query';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';
import {
  MultiraceProgram,
  RaceProgram,
  useGetCalendarLazyQuery,
} from '@/lib/apollo/types/gen/graphql';
import { dayjst } from '@/lib/dayjst';

const Calendar: React.FC = () => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  useLayoutEffect(() => {
    setLayoutStyles();
  }, []);

  const location = useLocation();

  const paramDate = new URLSearchParams(location.search).get(DATE_PARAM_KEY);
  const targetDate = paramDate ? dayjst(paramDate) : dayjst();

  const [loadCalendar, calendarQuery] = useGetCalendarLazyQuery();

  useEffect(() => {
    const timeRangeCondition = {
      since: targetDate.startOf('month'),
      until: targetDate.endOf('month'),
    };
    loadCalendar({
      variables: {
        raceProgramsInput: {
          timeRangeCondition,
        },
        multiraceProgramsInput: {
          timeRangeCondition,
        },
      },
    });

    setBreadcrumbs([
      {
        name: '開催スケジュール',
        to: '/calendar',
      },
      {
        name: targetDate.format('YYYY年M月'),
        to: '',
      },
    ]);
  }, [paramDate]);

  const title = location.search
    ? `${targetDate.format('YYYY年MM月')}の開催スケジュール`
    : `開催スケジュール${targetDate.format('YYYY年MM月')}`;

  return (
    <>
      <Helmet
        meta={{
          title: `競輪 ${title}`,
          description: '競輪の開催スケジュールです。%s',
          keywords: `${title},%s`,
        }}
      />
      <CalendarTemplate
        date={targetDate}
        racePrograms={(calendarQuery.data?.racePrograms || []) as RaceProgram[]}
        multiracePrograms={
          (calendarQuery.data?.multiracePrograms || []) as MultiraceProgram[]
        }
      />
    </>
  );
};

export default Calendar;
